// Item icons in the Inkwell style, made from the little pixel pictures in shared/items.ts: every coloured pixel
// becomes a soft round dab, the dabs melt together, and an ink line goes round the whole shape. Built once and
// reused, at 8 pixels per original pixel (96 x 96) so they stay sharp in the bag.
import { itemDef } from '../../../shared/items.js';

const cache = new Map<string, HTMLCanvasElement>();
const OUTLINE = '#2f2a26', INK = '#3e2f28', C = 8, N = 12;

export function itemIcon(id: string): HTMLCanvasElement {
  let cv = cache.get(id);
  if (cv) return cv;
  cv = document.createElement('canvas'); cv.width = N * C; cv.height = N * C;
  const d = itemDef(id), g = cv.getContext('2d')!;
  const cells: { x: number; y: number; col: string; line: boolean }[] = [];
  if (d) d.icon.forEach((row, y) => { for (let x = 0; x < row.length; x++) { const k = row[x], col = k !== '.' ? d.colors[k] : undefined; if (col) cells.push({ x, y, col, line: col.toLowerCase() === OUTLINE }); } });
  else for (let y = 3; y < 9; y++) for (let x = 3; x < 9; x++) cells.push({ x, y, col: '#c9bda4', line: false });
  const dab = (x: number, y: number, r: number) => { g.moveTo((x + 0.5) * C + r, (y + 0.5) * C); g.arc((x + 0.5) * C, (y + 0.5) * C, r, 0, Math.PI * 2); };
  // the ink line: every pixel of the shape (the old outline pixels included), a little fatter
  g.fillStyle = INK; g.beginPath(); for (const c of cells) dab(c.x, c.y, C * 0.86); g.fill();
  // the colours: outline pixels take their neighbour's colour, so the shape is filled right to the line
  const at = new Map(cells.map(c => [`${c.x},${c.y}`, c]));
  const colOf = (c: typeof cells[number]) => { if (!c.line) return c.col; for (const [dx, dy] of [[1, 0], [-1, 0], [0, 1], [0, -1], [1, 1], [-1, -1], [1, -1], [-1, 1]]) { const n = at.get(`${c.x + dx},${c.y + dy}`); if (n && !n.line) return n.col; } return null; };
  for (const c of cells) { const col = colOf(c); if (!col) continue; g.fillStyle = col; g.beginPath(); dab(c.x, c.y, C * (c.line ? 0.45 : 0.62)); g.fill(); }
  // a shine on the upper left
  g.globalCompositeOperation = 'source-atop'; g.fillStyle = 'rgba(255,255,255,0.22)'; g.beginPath(); g.ellipse(N * C * 0.36, N * C * 0.3, N * C * 0.2, N * C * 0.1, -0.6, 0, Math.PI * 2); g.fill();
  g.globalCompositeOperation = 'source-over';
  cache.set(id, cv);
  return cv;
}
